import { z } from "zod"

export const AttachmentSchema = z.object({
  id: z.string(),
  url: z.string(),
  name: z.string(),
  size: z.number(),
})

export type Attachment = z.infer<typeof AttachmentSchema>
